import { ShieldCheck } from 'lucide-react';
import { LinkButton } from '@/components/ui/Button';
import { EmptyState } from '@/components/ui/Feedback';

export function ForbiddenPage() {
  return (
    <EmptyState
      icon={<ShieldCheck aria-hidden className="size-5" />}
      title="You do not have access to this area"
      description="Your development role does not include this part of the platform. A Development Director can change that."
      action={
        <LinkButton to="/" variant="primary">
          Back to the dashboard
        </LinkButton>
      }
    />
  );
}
